import withPreview from '../../hoc/WithPreview/WithPreview.js';
import tmpl from './Newsletter.jsx';

const Newsletter = (props) => tmpl();

export default withPreview(Newsletter);
